/* eslint-disable react-hooks/exhaustive-deps */
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import Avatar from 'react-avatar';
import { useTranslation } from 'react-i18next';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import { useDispatch, useSelector } from 'react-redux';
import * as auth from '../../store/actions/auth.action';
import * as types from '../../store/actions/types';
import { RootState } from '../../store/reducers';
import errorMessages from '../../utils/errorMessages';
import { buyNewDomain, checkAppraisalRouter, checkDomainHasExtension, closePopup, closeWindows, docIds, getLocalStorageValue, getPublicRegistrarAvatarURL, handleToast, historyPath, historyPush, isInValidPassword, isUserRole, isValidDomainName, isValidEmail, localStorageKeyValue, loginSignUpSuccess, removeLocalStorageValue, setLocalStorageValue, storeToken, userInterested } from '../../utils/handler';
import { NumberInput } from './CommonPages';
import { GoogleLoginComponent } from './socialLogin.component';

const LoginWindow = (props: any): JSX.Element => {
  const { t } = useTranslation();
  const { previousAction = '', showSignUpWindow, showLoginWindowWithDomain } = useSelector((state: RootState) => state.mainReducer);
  const [password, changePassword] = useState('');
  const [email, changeEmail] = useState(getLocalStorageValue(localStorageKeyValue.userEmail));
  const [acceptTerms, setAcceptTerms] = useState(false);

  const [c_password, changeCPassword] = useState('');
  const [domainName, setDomainName] = useState('');
  const [offerAmount, setOfferAmount] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showCPassword, setShowCPassword] = useState(false);
  const [isFormSubmitted, setFormSubmitted] = useState(false);
  const [formType, setFormType] = useState('Login');
  // const [isNotAppraisalPage, setIsNotAppraisalPage] = useState(true);
  const { localCountryStr } = useSelector((state: RootState) => state.mainReducer);

  // const [phoneValidationError, setPhoneValidationError] = useState("")
  const [showLoading, setShowLoading] = useState(false);
  let history = props.history;
  const dispatch = useDispatch();

  const phoneNumberChange = (value: any) => {
    // if (!value || (value && isValidPhoneNumber(value))) {
    //     setPhoneValidationError("")
    // }
    // if (isFormSubmitted && value && !isValidPhoneNumber(value)) {
    //     setPhoneValidationError("Invalid phone number")
    // }
    setPhone(value);
  };
  useEffect(() => {
    if (showSignUpWindow) {
      clickSignUp();
    }
  }, [showSignUpWindow]);

  useEffect(() => {
    let localStorageEmail = localStorage.getItem(localStorageKeyValue.userEmail);
    if (localStorageEmail) {
      changeEmail(localStorageEmail);
    }
    // let isExist = _.find(appraisalRoutes, {path: history.location.pathname});
    // if (isExist) {
    //   setIsNotAppraisalPage(false);
    // }
    let domainName = getLocalStorageValue(localStorageKeyValue.domainName);
    if (domainName) {
      setDomainName(domainName);
    }
  }, [getLocalStorageValue(localStorageKeyValue.domainName)]);
  const checkFormValid = () => {
    if (!email) {
      return false;
    } else if (!acceptTerms) {
      return false;
    } else if (isValidEmail(email)) {
      handleToast({ message: errorMessages.invalidEmail });
      return false;
    } else if (isInValidPassword(password)) {
      handleToast({ message: errorMessages.passwordInvalidContent });
      return false;
    } else if (password !== c_password) {
      handleToast({ message: errorMessages.passwordMustMatch });
      return false;
    }

    return true;
  };
  // const checkValidDomain = () => {
  //   let isValid = false;
  //   if (phone && email && name && domainName) {
  //     if (!isValidEmail(email)) {
  //       isValid = true;
  //     }
  //   }
  //   return isValid;
  // };

  const checkValidForm = () => {
    if (!email) {
      return false;
    } else if (isValidEmail(email)) {
      return false;
    } else if (name === '') {
      return false;
    } else if (domainName === '') {
      return false;
    } else if (!offerAmount) {
      return false;
    } else if (!acceptTerms) {
      return false;
    } else if (isInValidPassword(password)) {
      handleToast({ message: errorMessages.passwordInvalidContent });
      return false;
    }
    if (!isValidPhoneNumber(phone) || !phone) {
      return false;
    }

    if (!checkDomainHasExtension(domainName)) {
      handleToast({ message: errorMessages.domainWithoutExtension });
      return false;
    }
    return true;
  };
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormSubmitted(true);
    if (showLoginWindowWithDomain) {
      if (checkValidForm()) {
        let payload = {
          email,
          name,
          phone,
          domainName,
          password,
          // confirmPassword: password,
          offerAmount,
        };

        // if (domainName) {
        //   setLocalStorageValue(localStorageKeyValue.domainName, domainName);
        //   setLocalStorageValue(localStorageKeyValue.offerAmount, offerAmount);
        //   dispatch({type: types.PREVIOUS_ACTION, payload: previousAction.buyDomain});
        // }
        // console.log(payload)
        setShowLoading(true);
        await auth.signUpWithDomain(payload);
        setShowLoading(false);
        // .then((res: any) => {
        // if (res) {
        //   let data = res['data'];
        //   // loginSuccess(res);
        //   // let data = res['data'];
        //   // if (res.status === 203) {
        //   //   handleToast({message: data});
        //   //   dispatch({type: types.SIGN_UP_WITH_DOMAIN, payload: false});
        //   // } else if (res.status === 200) {
        //   //   dispatch({type: types.SHOW_LOGIN_WINDOW, payload: false});
        //   loginSignUpSuccess(data).then((result) => {
        //     // if (domainName) {
        //     //   navigateUserLogin(domainName);
        //     // } else {
        //     // loginSuccess(res);
        //     // }
        //   });
        //   // }
        // }
        // setShowLoading(false);
        // });
      }
      // else {
      //   handleToast({message: errorMessages.invalidDomain})
      // }
    } else if (formType === 'signUp') {
      if (checkFormValid()) {
        setShowLoading(true);
        auth.signup({ password, email, confirmPassword: c_password }).then((res: any) => {
          if (res) {
            loginSuccess(res);
          }
          setShowLoading(false);
        });
      }
    } else if (password) {
      setShowLoading(true);
      auth.login({ password, email }).then((res: any) => {
        if (res) {
          loginSuccess(res);
        }
        setShowLoading(false);
      });
    }
  };

  const loginSuccess = (res: any) => {
    if (domainName) {
      setLocalStorageValue(localStorageKeyValue.domainName, domainName);
    }
    removeLocalStorageValue(localStorageKeyValue.password);
    storeToken(res).then(() => {
      // handleToast({ message: "Success" }, 'success')
      // if (previousAction === '') {
      //   // historyPush(historyPath.dashboard);
      // }
      if (previousAction === '/dashboard') {
        historyPush(historyPath.dashboard);
      }
      closeWindows();
    });
  };
  const forgotPassword = () => {
    dispatch({ type: types.SHOW_LOGIN_WINDOW, payload: false });
    history.push('/forgot-password', { email: email, returnURL: history.location.pathname + history.location.search });
  };
  // const closeLoginWindow = () => {
  //   dispatch({type: types.PREVIOUS_ACTION, payload: ''});
  //   dispatch({type: types.SHOW_LOGIN_WINDOW, payload: false});
  // };
  const clickSignUp = () => {
    if (checkAppraisalRouter()) {
      dispatch({ type: types.SHOW_UPGRADE_WINDOW, payload: true });
    } else {
      setFormType('signUp');
    }
  };
  return (
    <div className="custom-popup-window ">
      <div className={'card relogin-form ' + (showLoginWindowWithDomain ? ' domain-login-form' : '')}>
        <div className="d-flex justify-content-between align-items-center pl-3 pr-3" onClick={closePopup}>
          <div className="title pb-0 mb-0">
            <span className="ml-2">{showLoginWindowWithDomain ? 'Get Started With Saw.com' : formType === 'signUp' ? t('Sign Up') : t('Login')}</span>
          </div>
          <div>
            <i className="fas fa-times mr-1 fa-2x f-bold fa-custom-rotate-z"></i>
          </div>
        </div>
        <div className="card-body overflow-auto">
          <div className=" ">
            <form onSubmit={submit} className="custom-form text-left">
              {showLoginWindowWithDomain ? (
                <div>
                  <div className="form-group">
                    <input autoComplete="off" type="text" className={'  form-control saw-input ' + (isFormSubmitted && name === '' ? 'is-invalid' : '')} name="name" value={name} onChange={(e) => setName(e.target.value)} placeholder={t('Enter Name*')} title="" required />
                    <div className="invalid-feedback">{t('Please Enter Your Name')}</div>
                  </div>
                  <div className="form-group">
                    <input autoComplete="off" type="email" className={' form-control saw-input ' + ((isFormSubmitted && isValidEmail(email)) || (isFormSubmitted && email === '') ? 'is-invalid' : '')} name="email" value={email} onChange={(e) => changeEmail(e.target.value)} placeholder={t('Enter your Email*')} title="" required />
                    <div className="invalid-feedback">{t('Please Enter Valid Email Address')}</div>
                  </div>
                  <div className="form-group password-container" id="show_hide_password">
                    <input
                      autoComplete="off"
                      type={showPassword ? 'text' : 'password'}
                      // onPaste={(e) => { e.preventDefault(); return false }}
                      className={'custom-input form-control saw-input ' + (isFormSubmitted && (!password || isInValidPassword(password)) ? 'is-invalid' : '')}
                      name="password"
                      value={password}
                      onChange={(e) => changePassword(e.target.value)}
                      placeholder="Password*"
                      title=""
                      required
                    />
                    {password && <i className={'password-eye fa-lg theme-color c-pointer fa fa-eye' + (showPassword ? '' : '-slash')} onClick={() => setShowPassword(!showPassword)} aria-hidden="true"></i>}
                    <div className="invalid-feedback">{t('Please Valid Password')}</div>
                    {/* {password && isInValidPassword(password) ? <div className="invalid-feedback">{errorMessages.passwordInvalidContent}</div> : null} */}
                  </div>
                  <div className="form-group">
                    <PhoneInput international defaultCountry={localCountryStr} placeholder="Phone Number*" value={phone || undefined} onChange={(data) => phoneNumberChange(data || '')} className="form-control" rules={{ required: true }} />
                    <div className="invalid-feedback error-message  ">{t('Please Enter Phone Number')}</div>

                    {isFormSubmitted && !phone && <div className="text-danger error-message">{t('Please Enter Valid Phone Number')}</div>}
                    {isFormSubmitted && phone && !isValidPhoneNumber(phone) ? <div className="text-danger error-message">{t('Invalid phone number')}</div> : null}
                  </div>
                  <div className="form-group">
                    {/* <label className="  ">{t("Domain Name")}</label> */}
                    <input autoComplete="off" type="text" className={'custom-input form-control saw-input ' + (isFormSubmitted && domainName === '' ? 'is-invalid' : '')} name="domainName" value={domainName} onChange={(e) => setDomainName(e.target.value)} placeholder={t('Enter Domain Name*')} title="" />
                    <div className="invalid-feedback">{t('Please Enter Domain Name')}</div>
                  </div>

                  <div className="form-group ">
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <div className="input-group-text btn-group-input" id="btnGroupAddon">
                          $
                        </div>
                      </div>
                      <NumberInput placeholder="Budget *" value={offerAmount} name="offerAmount" onChange={(e: React.ChangeEvent<HTMLInputElement>) => setOfferAmount(e.target.value)} required />
                    </div>
                    {isFormSubmitted && !offerAmount && <div className="text-danger error-message">{t('Please Enter Your budget')}</div>}
                  </div>

                  <div className="form-check-label fs-14 col-12 pl-0">
                    <input type="checkbox" name="acceptTerms" checked={acceptTerms} onChange={() => setAcceptTerms(!acceptTerms)} className={'form-check-input saw-check-box '} id="opt_in_terms_checkbox" />
                    <label htmlFor="opt_in_terms_checkbox" className="">
                      By ticking this box I agree that I have read and consent to the{' '}
                      <a className="theme-color hover-u" href="https://saw.com/privacy-policy" target="_blank" rel="noopener noreferrer">
                        Privacy Policy
                      </a>{' '}
                      and{' '}
                      <a className="theme-color hover-u" href="https://saw.com/terms-of-service" target="_blank" rel="noopener noreferrer">
                        Terms of Service
                      </a>{' '}
                    </label>
                    {isFormSubmitted && !acceptTerms ? <div className="text-danger">Please Accept Privacy Policy and Terms of Service</div> : null}
                  </div>
                </div>
              ) : (
                <>
                  <div className="mt-2">
                    {/* <label className="  ">{t("Email")}</label> */}
                    <input autoComplete="off" type="email" className={'custom-input form-control saw-input ' + ((isFormSubmitted && isValidEmail(email)) || (isFormSubmitted && email === '') ? 'is-invalid' : '')} name="email" value={email} onChange={(e) => changeEmail(e.target.value)} placeholder={t('Enter your Email*')} title="" />
                    <div className="invalid-feedback">{t('Please Enter Valid Email Address')}</div>
                  </div>
                  <div className="mt-2">
                    {/* <label className="">{t('Password')}</label> */}
                    <div className=" form-group input-group password-container ">
                      <input autoComplete="off" type={showPassword ? 'text' : 'password'} className={'form-control ' + (isFormSubmitted && (password === '' || isInValidPassword(password)) ? 'is-invalid' : '')} name="password" value={password} onChange={(e) => changePassword(e.target.value)} placeholder="Password" />
                      {password && <i className={'password-eye fa-lg   theme-color fa fa-eye' + (showPassword ? '' : '-slash')} onClick={() => setShowPassword(!showPassword)} aria-hidden="true"></i>}
                      <div className="invalid-feedback">{errorMessages.passwordMissing}</div>
                    </div>
                  </div>
                  {formType === 'signUp' && (
                    <div className="mt-2">
                      {/* <label className="">{t('Confirm Password')}</label> */}
                      <div className="input-group password-container" id="show_hide_password">
                        <input
                          autoComplete="off"
                          type={showCPassword ? 'text' : 'password'}
                          // onPaste={(e) => { e.preventDefault(); return false }}
                          className={'custom-input form-control saw-input ' + (isFormSubmitted && (c_password === '' || password !== c_password) ? 'is-invalid' : '')}
                          name="c_password"
                          value={c_password}
                          onChange={(e) => changeCPassword(e.target.value)}
                          placeholder="Confirm Password*"
                          title=""
                        />
                        {c_password && <i className={'password-eye fa-lg theme-color c-pointer fa fa-eye' + (showCPassword ? '' : '-slash')} onClick={() => setShowCPassword(!showCPassword)} aria-hidden="true"></i>}
                        <div className="invalid-feedback">{t('password and confirm password must match')}</div>
                      </div>
                    </div>
                  )}
                  {formType === 'signUp' && (
                    <div className="form-check-label fs-14 col-12 pl-0">
                      <input type="checkbox" name="acceptTerms" checked={acceptTerms} onChange={() => setAcceptTerms(!acceptTerms)} className={'form-check-input saw-check-box '} id="opt_in_terms_checkbox" />
                      <label htmlFor="opt_in_terms_checkbox" className="">
                        By ticking this box I agree that I have read and consent to the{' '}
                        <a className="theme-color hover-u" href="https://saw.com/privacy-policy" target="_blank" rel="noopener noreferrer">
                          Privacy Policy
                        </a>{' '}
                        and{' '}
                        <a className="theme-color hover-u" href="https://saw.com/terms-of-service" target="_blank" rel="noopener noreferrer">
                          Terms of Service
                        </a>{' '}
                      </label>
                      {isFormSubmitted && !acceptTerms ? <div className="text-danger">Please Accept Privacy Policy and Terms of Service</div> : null}
                    </div>
                  )}

                  {formType !== 'signUp' && (
                    <div className="  text-right">
                      <span className="hover-u" onClick={forgotPassword}>
                        {t('Forgot Password?')}
                      </span>
                    </div>
                  )}

                  <div className="text-center">
                    {formType === 'signUp' ? (
                      <span className="hover-u" onClick={() => setFormType('Login')}>
                        {t('Login')}
                      </span>
                    ) : (
                      <span className="hover-u" onClick={clickSignUp}>
                        {t('Sign Up')}
                      </span>
                    )}
                  </div>
                </>
              )}

              <div className="form-row justify-content-center">
                <button className="btn btn-grad" disabled={showLoading} onClick={submit}>
                  {t(showLoginWindowWithDomain ? 'Get Started' : 'Submit')}
                </button>
              </div>
            </form>
            {/* {isNotAppraisalPage && ( */}
            <div className=" form-row justify-content-center">
              <GoogleLoginComponent onSuccess={loginSuccess} disabled={showLoading} />
            </div>
            {/* )}  */}
            {/* <div className="form-row justify-content-center  ">
              <span className="c-pointer" onClick={closeLoginWindow}>
                {t('Cancel')}
              </span>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginWindow;

export const DomainForm = () => {
  const { t } = useTranslation();
  const [domainName, setDomainName] = useState(getLocalStorageValue(localStorageKeyValue.domainName));
  const [name, setName] = useState(getLocalStorageValue(localStorageKeyValue.userName));
  const [offerAmount, setOfferAmount] = useState(getLocalStorageValue(localStorageKeyValue.offerAmount));
  const [phone, setPhone] = useState(getLocalStorageValue(localStorageKeyValue.phone));
  const [email, changeEmail] = useState(getLocalStorageValue(localStorageKeyValue.userEmail));
  const [isFormSubmitted, setFormSubmitted] = useState(false);
  const { registrarDetails } = useSelector((state: RootState) => state.userReducer);
  const { myProfile } = useSelector((state: RootState) => state.userReducer);
  const { localCountryStr } = useSelector((state: RootState) => state.mainReducer);
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('');

  // const history = useHistory();

  const phoneNumberChange = (value: any) => {
    // if (!value || (value && isValidPhoneNumber(value))) {
    //     setPhoneValidationError("")
    // }
    // if (isFormSubmitted && value && !isValidPhoneNumber(value)) {
    //     setPhoneValidationError("Invalid phone number")
    // }
    setPhone(value);
  };

  const checkValidForm = () => {
    if (!email) {
      return false;
    } else if (isValidEmail(email)) {
      return false;
    } else if (name === '') {
      return false;
    } else if (!offerAmount) {
      return false;
    } else if (domainName === '') {
      return false;
    } else if (isInValidPassword(password)) {
      return false;
    }
    if (!isValidPhoneNumber(phone) || !phone) {
      return false;
    }
    // if (phoneValidationError === "") {
    //     return false
    // }
    if (!isValidDomainName(domainName)) {
      handleToast({ message: errorMessages.domainWithoutExtension });
      return false;
    }
    return true;
  };

  const signUpWithDomain = (e: React.FormEvent) => {
    e.preventDefault();
    setFormSubmitted(true);
    if (checkValidForm()) {
      if (isValidDomainName(domainName)) {
        // let payload = {
        //     email, name, phone, offerAmount, domainName
        // }
        // setShowLoading(true)
        // auth.createCloseContactUsLead(payload).then((res: BaseResponse) => {
        //     if (res) {
        //         handleToast({ message: ("Form Submitted, One of our agents will get back to you within one business day or less.") }, "success")
        //     }
        //     setShowLoading(false)
        // })
        let payload = {
          email,
          name,
          phone,
          domainName,
          offerAmount: offerAmount,
          password,
          // confirmPassword: password,
        };
        // setLocalStorageValue(localStorageKeyValue.domainName, domainName);
        // setLocalStorageValue(localStorageKeyValue.offerAmount, offerAmount);
        // dispatch({type: types.PREVIOUS_ACTION, payload: previousActionConfigs.buyDomain});
        // console.log(domainName, '---------  buyDomain  -----------');

        if (email === myProfile?.email) {
          if (isUserRole()) {
            buyNewDomain(domainName, offerAmount);
          } else {
            historyPush(historyPath.dashboard);
          }
        } else {
          // handlePageLoader(true);
          auth.signUpWithDomain(payload);
          // .then((res: any) => {
          // if (res) {
          //   // loginSignUpSuccess(res).then((result) => {
          //   //   closeWindows();
          //   // });
          //   let data = res['data'];
          //   closeWindows();
          //   loginSignUpSuccess(data).then((result) => {
          //     // if (domainName) {
          //     //   navigateUserLogin(domainName);
          //     // } else {
          //     // loginSuccess(data);
          //     // }
          //   });

          //   // if (res.status === 203) {
          //   //   handleToast({message: data});
          //   //   dispatch({type: types.PREVIOUS_ACTION, payload: '/dashboard'});
          //   //   dispatch({type: types.SHOW_LOGIN_WINDOW, payload: true});
          //   //   setLocalStorageValue(localStorageKeyValue.userEmail, email);
          //   //   setLocalStorageValue(localStorageKeyValue.userName, name);
          //   //   setLocalStorageValue(localStorageKeyValue.phone, phone);
          //   //   // buyNewDomain(domainName, offerAmount)
          //   // } else if (res.status === 200) {
          //   //   sessionStorage.removeItem('registrarDetails');
          //   //   if (domainName) setLocalStorageValue(localStorageKeyValue.domainName, domainName);
          //   //   // localStorage.setItem('domainName', domainName);
          //   //   loginSignUpSuccess(data);
          //   //   // .then(() => {
          //   //   // navigateUserLogin(domainName, offerAmount);
          //   //   // });
          //   // }
          // }
          // handlePageLoader(false);
          // });
        }
      } else {
        handleToast({ message: errorMessages.invalidDomain }, 'success');
      }
    }
  };
  return (
    <div className="card">
      {!_.isEmpty(registrarDetails) && (
        <div className="saw_registrar_logo ">
          <div className="logo-content theme-color">Delivered By: </div>
          <Avatar className="edit-user-image ml-2" textSizeRatio={3} onClick={() => document.getElementById('Upload-image')?.click()} src={getPublicRegistrarAvatarURL(registrarDetails?.UID, registrarDetails?.image)} name={registrarDetails.name} />

          {/* Saw plus registrar logo */}
          {/* <div className="saw_registrar_logo">
            <div className=" edit-user-image ml-2 c-pointer">
              <img src={getPublicRegistrarAvatarURL(registrarDetails?.UID, registrarDetails?.image)} className=" " alt="Img" onClick={() => document.getElementById('Upload-image')?.click()}></img>
            </div>
            <i className="fas fa-plus mr-1 fa-2x f-bold"></i>
            <div className=" edit-user-image ml-2 c-pointer">
              <img src={logo} className=" " alt="Img" onClick={() => document.getElementById('Upload-image')?.click()}></img>
            </div>
          </div> */}
        </div>
      )}
      <div className="  domain-form ">
        <form onSubmit={signUpWithDomain} className="custom-form" id={docIds.domainEnquiryForm}>
          <div className="form-group">
            <input autoComplete="off" type="text" className={'  form-control saw-input ' + (isFormSubmitted && name === '' ? 'is-invalid' : '')} name="name" value={name} onChange={(e) => setName(e.target.value)} placeholder={t('Full Name *')} title="" required />
            <div className="invalid-feedback">{t('Please Enter Your Name')}</div>
          </div>
          <div className="form-group">
            <input autoComplete="off" type="email" className={' form-control saw-input ' + ((isFormSubmitted && isValidEmail(email)) || (isFormSubmitted && email === '') ? 'is-invalid' : '')} name="email" value={email} onChange={(e) => changeEmail(e.target.value)} placeholder={t('Email Address *')} title="" required />
            <div className="invalid-feedback">{t('Please Enter Valid Email Address')}</div>
          </div>
          <div className="form-group">
            <div className=" form-group input-group password-container ">
              <input
                autoComplete="off"
                type={showPassword ? 'text' : 'password'}
                className={'form-control ' + (isFormSubmitted && (password === '' || isInValidPassword(password)) ? 'is-invalid' : '')}
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                // pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$"
              />
              {password && <i className={'password-eye fa-lg   theme-color fa fa-eye' + (showPassword ? '' : '-slash')} onClick={() => setShowPassword(!showPassword)} aria-hidden="true"></i>}
              <div className="invalid-feedback">{t('passwordRule')}</div>
            </div>
          </div>
          <div className="form-group">
            <PhoneInput international defaultCountry={localCountryStr} placeholder="Phone Number*" value={phone || undefined} onChange={(data) => phoneNumberChange(data || '')} className="form-control" rules={{ required: true }} />
            <div className="invalid-feedback error-message  ">{t('Please Enter Phone Number')}</div>
            {isFormSubmitted && !phone && <div className="text-danger error-message">{t('Please Enter Valid Phone Number')}</div>}
            {isFormSubmitted && phone && !isValidPhoneNumber(phone) ? <div className="text-danger error-message">{t('Invalid phone number')}</div> : null}
          </div>
          <div className="form-group">
            <input autoComplete="off" type="text" className={'custom-input form-control saw-input ' + (isFormSubmitted && domainName === '' ? 'is-invalid' : '')} name="domainName" value={domainName} onChange={(e) => setDomainName(e.target.value)} placeholder={t('Domain Name *')} title="" />
            <div className="invalid-feedback">{t('Please Enter Your Domain Name')}</div>
          </div>
          <div className="form-group">
            <div className="input-group">
              <div className="input-group-prepend">
                <div className="input-group-text btn-group-input" id="btnGroupAddon">
                  $
                </div>
              </div>
              <NumberInput id={docIds.domainBudget} placeholder="Budget *" value={offerAmount} name="offerAmount" onChange={(e: React.ChangeEvent<HTMLInputElement>) => setOfferAmount(e.target.value)} required />
            </div>
            {isFormSubmitted && !offerAmount && <div className="text-danger error-message">{t('Please Enter Your budget')}</div>}
          </div>

          <div className="form-row justify-content-center mt-4">
            <button className="btn btn-grad" onClick={signUpWithDomain}>
              {t('get started')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export const UpgradeAccount = () => {
  // console.log(getLocalStorageValue(localStorageKeyValue.interestIn))
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, changeEmail] = useState(localStorage.getItem('userEmail') || '');
  const [isFormSubmitted, setFormSubmitted] = useState(false);
  const dispatch = useDispatch();
  // const [userInterest, setUserInterest] = useState(getLocalStorageValue(localStorageKeyValue.interestIn) || userInterested.buy);
  const userInterest = getLocalStorageValue(localStorageKeyValue.interestIn) || userInterested.buy;
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const { appraisalLimit } = useSelector((state: RootState) => state.appraisalReducer);
  const { localCountryStr } = useSelector((state: RootState) => state.mainReducer);
  const [showPassword, setShowPassword] = useState(false);
  const [showCPassword, setShowCPassword] = useState(false);

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const phoneNumberChange = (value: any) => {
    setPhone(value);
  };

  const checkValidForm = () => {
    if (!email) {
      return false;
    } else if (isValidEmail(email)) {
      return false;
    } else if (name === '') {
      return false;
    } else if (isInValidPassword(password)) {
      return false;
    } else if (password !== confirmPassword) {
      // handleToast({message: errorMessages.passwordMustMatch})
      return false;
    }
    if (!isValidPhoneNumber(phone) || !phone) {
      return false;
    } else if (!acceptTerms) {
      return false;
    }
    return true;
  };

  const upgradeWithDomain = (e: React.FormEvent) => {
    e.preventDefault();
    setFormSubmitted(true);
    if (checkValidForm()) {
      let payload = {
        email,
        name,
        phone,
        userInterested: userInterest,
        password,
        confirmPassword,
      };
      setShowLoading(true);
      setLocalStorageValue(localStorageKeyValue.userEmail, email);
      auth.signup(payload).then((res: any) => {
        if (res) {
          loginSignUpSuccess(res).then((result) => {
            closeWindows();
          });
          //   let data = res['data'];
          //   // dispatch({type: types.PREVIOUS_ACTION, payload: previousActionConfigs.buyDomain});
          //   if (res.status === 203) {
          //     handleToast({message: data});
          //     dispatch({type: types.SHOW_LOGIN_WINDOW, payload: true});
          //     dispatch({type: types.SIGN_UP_WITH_DOMAIN, payload: false});
          //     dispatch({type: types.SHOW_UPGRADE_WINDOW, payload: false});
          //   } else if (res.status === 200) {
          //     loginSignUpSuccess(data).then((result) => {
          //       console.log('result', result)
          //       closeWindows();
          //     });
          //   }
        }
        setShowLoading(false);
      });
    }
  };

  return (
    <div className="custom-popup-window ">
      <div className={'card popup-card lr25'}>
        <div className="d-flex justify-content-end">
          <i className="fas fa-times mr-1 fa-2x f-bold fa-custom-rotate-z" onClick={closePopup}></i>
        </div>
        <div className="fs-25 f-bold p-3 text-center lh-35 ">
          Create a Free Saw.com Account or{' '}
          <span
            className="theme-color c-pointer f-bold underline"
            onClick={() => {
              dispatch({ type: types.SIGN_UP_WITH_DOMAIN, payload: false });
              dispatch({ type: types.SHOW_LOGIN_WINDOW, payload: true });
            }}
          >
            {' '}
            Login
          </span>{' '}
          To Unlock More Appraisals
        </div>
        <div className="card-body plr-20">
          <div className="text-center ">
            <p>If you want to appraise more domains and benefit from some additional Saw.com features, all you need to do is create your free account. It’s super easy to get involved, just fill in your details below and get instant access to all of this:</p>
          </div>
          <ul className="theme-bullets">
            <li>{appraisalLimit.appraisalLimitWithLogin} daily appraisal searches with added data.</li>
            <li>Dedicated Domain Broker to assist with up to 5 acquisitions</li>
            <li>Domain Acquisitions eBook by Saw.com CEO Jeffrey Gabriel</li>
          </ul>
          <form onSubmit={upgradeWithDomain} className="custom-form px-1" id={docIds.domainEnquiryForm}>
            <div className="form-group">
              <input autoComplete="off" type="text" className={'  form-control saw-input ' + (isFormSubmitted && name === '' ? 'is-invalid' : '')} name="name" value={name} onChange={(e) => setName(e.target.value)} placeholder={t('Enter Name*')} title="" />
              <div className="invalid-feedback">{t('Please Enter Your Name')}</div>
            </div>
            <div className="form-group">
              <input autoComplete="off" type="email" className={' form-control saw-input ' + ((isFormSubmitted && isValidEmail(email)) || (isFormSubmitted && email === '') ? 'is-invalid' : '')} name="email" value={email} onChange={(e) => changeEmail(e.target.value)} placeholder={t('Enter your Email*')} title="" />
              <div className="invalid-feedback">{t('Please Enter Valid Email Address')}</div>
            </div>
            <div className="form-group">
              <PhoneInput international defaultCountry={localCountryStr} placeholder="Phone Number*" value={phone || undefined} onChange={(data) => phoneNumberChange(data || '')} className="form-control" />
              <div className="invalid-feedback error-message  ">{t('Please Enter Phone Number')}</div>

              {isFormSubmitted && !phone && <div className="text-danger error-message">{t('Please Enter Valid Phone Number')}</div>}
              {isFormSubmitted && phone && !isValidPhoneNumber(phone) ? <div className="text-danger error-message">{t('Invalid phone number')}</div> : null}
            </div>
            <div className="form-group">
              <div className=" form-group input-group password-container ">
                <input
                  autoComplete="off"
                  type={showPassword ? 'text' : 'password'}
                  className={'form-control ' + (isFormSubmitted && (password === '' || isInValidPassword(password)) ? 'is-invalid' : '')}
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                  // pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$"
                />
                {password && <i className={'password-eye fa-lg   theme-color fa fa-eye' + (showPassword ? '' : '-slash')} onClick={() => setShowPassword(!showPassword)} aria-hidden="true"></i>}
                <div className="invalid-feedback">{t('passwordRule')}</div>
              </div>
            </div>
            <div className="form-group">
              <div className="input-group password-container">
                <input autoComplete="off" type={showCPassword ? 'text' : 'password'} className={'form-control ' + (isFormSubmitted && (confirmPassword === '' || password !== confirmPassword) ? ' is-invalid' : '')} name="confirmPassword" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Confirm Password" />
                {confirmPassword && <i className={'password-eye fa-lg   theme-color fa fa-eye' + (showCPassword ? '' : '-slash')} onClick={() => setShowCPassword(!showCPassword)} aria-hidden="true"></i>}
                <div className="invalid-feedback">{t('password and confirm password must match')}</div>
              </div>
            </div>

            {/* <div className="  ">
              <label className="mt-2 fw-600">{t('How would you like to be contacted?')}</label>
              <div className="choose-widget ml--10">
                <div className="f-bold d-flex  options ">
                  <div className="form-check form-check-inline  ">
                    <input className="form-check-input" checked={userInterest === userInterested.buy} onChange={() => setUserInterest(userInterested.buy)} type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1" />
                    <label className="mt-2  " htmlFor="inlineRadio1 ">
                      {t(userInterested.buy)}
                    </label>
                    <i className="theme-color fas fa-question-circle ml-1 fa-xs" title={interestToolTip.buy} onClick={() => alert(interestToolTip.buy)}></i>
                  </div>
                  <div className="form-check form-check-inline ml-2 ">
                    <input className="form-check-input " checked={userInterest === userInterested.sell} onChange={() => setUserInterest(userInterested.sell)} type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2" />
                    <label className="mt-2 " htmlFor="inlineRadio2">
                      {t(userInterested.sell)}
                    </label>
                    <i className="theme-color fas fa-question-circle ml-1 fa-xs" title={interestToolTip.sell} onClick={() => alert(interestToolTip.sell)}></i>
                  </div>
                  <div className="form-check form-check-inline ml-2 ">
                    <input className="form-check-input " checked={userInterest === userInterested.investor} onChange={() => setUserInterest(userInterested.investor)} type="radio" name="inlineRadioOptions" id="inlineRadio3" value="option3" />
                    <label className="mt-2 " htmlFor="inlineRadio3">
                      {t(userInterested.investor)}
                    </label>
                    <i className="theme-color fas fa-question-circle ml-1 fa-xs" title={interestToolTip.investor} onClick={() => alert(interestToolTip.investor)}></i>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="form-check-label fs-14 col-12 pl-0">
              <input type="checkbox" name="acceptTerms" defaultChecked={acceptTerms} onClick={() => setAcceptTerms(!acceptTerms)} className={'form-check-input saw-check-box '} id="adventure_id" />
              <div className="">
                By ticking this box I agree that I have read and consent to the{' '}
                <a className="theme-color hover-u" href="https://saw.com/privacy-policy" target="_blank" rel="noopener noreferrer">
                  Privacy Policy
                </a>{' '}
                and{' '}
                <a className="theme-color hover-u" href="https://saw.com/terms-of-service" target="_blank" rel="noopener noreferrer">
                  Terms of Service
                </a>{' '}
              </div>
              {isFormSubmitted && !acceptTerms ? <div className="text-danger">Please Accept Privacy Policy and Terms of Service</div> : null}
            </div>
            <div className=" d-grid justify-content-center text-center mt-2">
              <button className="btn-grad btn " disabled={showLoading} onSubmit={upgradeWithDomain}>
                <span className="ml-2"> Create a free account</span>
              </button>
              <div>
                <span className="p-1">or</span>
              </div>
              <div>
                <span
                  className="theme-color c-pointer"
                  onClick={() => {
                    dispatch({ type: types.SIGN_UP_WITH_DOMAIN, payload: false });
                    dispatch({ type: types.SHOW_LOGIN_WINDOW, payload: true });
                  }}
                >
                  Already have an account?
                </span>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export const FillOutMandatoryFields = () => {
  // const { myProfile } = useSelector((state: RootState) => state.userReducer);
  const { t } = useTranslation();
  const { localCountryStr, googleProfile } = useSelector((state: RootState) => state.mainReducer);
  const [name, setName] = useState(googleProfile.name || '');
  const [phone, setPhone] = useState(googleProfile.phone || '');
  const [isFormSubmitted, setFormSubmitted] = useState(false);
  const dispatch = useDispatch();
  // const [userInterest, setUserInterest] = useState(userInterested.buy);
  const userInterest = userInterested.buy;
  const [acceptTerms, setAcceptTerms] = useState(false);
  // const [showLoading, setShowLoading] = useState(false);
  const showLoading = false;
  const checkValidForm = () => {
    if (name === '') {
      return false;
    }
    if (!isValidPhoneNumber(phone) || !phone) {
      return false;
    } else if (!acceptTerms) {
      return false;
    }
    return true;
  };

  const updateProfile = (e: React.FormEvent) => {
    e.preventDefault();
    setFormSubmitted(true);
    if (checkValidForm()) {
      let payload = {
        ...googleProfile,
        name,
        phone,
        userInterested: userInterest,
      };
      auth.socialLogin(payload).then((res) => {
        if (res) {
          loginSignUpSuccess(res);
          // console.log('res', res)
          dispatch({ type: types.GOOGLE_PROFILE, payload: {} });
        }
      });
      // updateMyProfile(payload).then(res => {
      //   if (res) {
      //     setShowLoading(false);
      //     setFormSubmitted(false)
      //     dispatch({type: types.UPDATE_PROFILE_WINDOW, payload: false})
      //   }
      // })
    }
  };
  const phoneNumberChange = (value: any) => {
    setPhone(value);
  };
  const closePopup = () => {
    dispatch({ type: types.GOOGLE_PROFILE, payload: {} });
  };

  return (
    <div className="custom-popup-window ">
      <div className={'card popup-card lr25'}>
        <div className="d-flex justify-content-end" onClick={closePopup}>
          <i className="fas fa-times mr-1 fa-2x f-bold fa-custom-rotate-z"></i>
        </div>
        <div className="fs-25 f-bold p-3 text-center lh-35 ">Please fill out the required Information</div>
        <div className="card-body plr-20">
          <form onSubmit={updateProfile} className="custom-form px-1" id={docIds.domainEnquiryForm}>
            <div className="form-group">
              <input autoComplete="off" type="text" className={'  form-control saw-input ' + (isFormSubmitted && name === '' ? 'is-invalid' : '')} name="name" value={name} onChange={(e) => setName(e.target.value)} placeholder={t('Enter Name*')} title="" />
              <div className="invalid-feedback">{t('Please Enter Your Name')}</div>
            </div>
            <div className="form-group">
              <PhoneInput international defaultCountry={localCountryStr} placeholder="Phone Number*" value={phone || undefined} onChange={(data) => phoneNumberChange(data || '')} className="form-control" />
              <div className="invalid-feedback error-message  ">{t('Please Enter Phone Number')}</div>

              {isFormSubmitted && !phone && <div className="text-danger error-message">{t('Please Enter Valid Phone Number')}</div>}
              {isFormSubmitted && phone && !isValidPhoneNumber(phone) ? <div className="text-danger error-message">{t('Invalid phone number')}</div> : null}
            </div>

            {/* <div className="  ">
              <label className="mt-2 fw-600">{t('How would you like to be contacted?')}</label>
              <div className="choose-widget ml--10">
                <div className="f-bold d-flex  options ">
                  <div className="form-check form-check-inline  ">
                    <input className="form-check-input" checked={userInterest === userInterested.buy} onChange={() => setUserInterest(userInterested.buy)} type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1" />
                    <label className="mt-2  " htmlFor="inlineRadio1 ">
                      {t(userInterested.buy)}
                    </label>
                    <i className="theme-color fas fa-question-circle ml-1 fa-xs" title={interestToolTip.buy} onClick={() => alert(interestToolTip.buy)}></i>
                  </div>
                  <div className="form-check form-check-inline ml-2 ">
                    <input className="form-check-input " checked={userInterest === userInterested.sell} onChange={() => setUserInterest(userInterested.sell)} type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2" />
                    <label className="mt-2 " htmlFor="inlineRadio2">
                      {t(userInterested.sell)}
                    </label>
                    <i className="theme-color fas fa-question-circle ml-1 fa-xs" title={interestToolTip.sell} onClick={() => alert(interestToolTip.sell)}></i>
                  </div>
                  <div className="form-check form-check-inline ml-2 ">
                    <input className="form-check-input " checked={userInterest === userInterested.investor} onChange={() => setUserInterest(userInterested.investor)} type="radio" name="inlineRadioOptions" id="inlineRadio3" value="option3" />
                    <label className="mt-2 " htmlFor="inlineRadio3">
                      {t(userInterested.investor)}
                    </label>
                    <i className="theme-color fas fa-question-circle ml-1 fa-xs" title={interestToolTip.investor} onClick={() => alert(interestToolTip.investor)}></i>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="form-check-label fs-14 col-12 pl-0">
              <input type="checkbox" name="acceptTerms" defaultChecked={acceptTerms} onClick={() => setAcceptTerms(!acceptTerms)} className={'form-check-input saw-check-box '} id="adventure_id" />
              <div className="">
                I have read and accept the{' '}
                <a className="theme-color hover-u" href="https://saw.com/privacy-policy" target="_blank" rel="noopener noreferrer">
                  Privacy Policy
                </a>{' '}
                and{' '}
                <a className="theme-color hover-u" href="https://saw.com/terms-of-service" target="_blank" rel="noopener noreferrer">
                  Terms of Service
                </a>{' '}
              </div>
              {isFormSubmitted && !acceptTerms ? <div className="text-danger">Please Accept Privacy Policy and Terms of Service</div> : null}
            </div>
            <div className="justify-content-center flex-center mt-2">
              <button className="btn-grad btn " disabled={showLoading} onSubmit={updateProfile}>
                <span className="ml-2"> Update Profile</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
